import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Colors, Metrics } from '../../Themes'

const Container = styled.div`
  width: 45px;
  height: 25px;
  background: ${props => (props.active ? Colors.greenBlue : Colors.lightGrey)};
  border-radius: 25px;
  display: block;
  position: relative;
  cursor: pointer;
`

const Circle = styled.div`
  border-radius: 18px;
  width: 18px;
  height: 18px;
  display: block;
  background: ${Colors.white};
  position: absolute;
  left: ${props => (props.active ? Metrics.margins.large : '3px')};
  top: 3px;
`

class Switch extends Component {
  shouldComponentUpdate (nextProps) {
    const { active } = this.props
    if (active !== nextProps.active) {
      return true
    }
    return false
  }

  render () {
    const { active } = this.props

    return (
      <Container active={active} {...this.props}>
        <Circle active={active} />
      </Container>
    )
  }
}

Switch.propTypes = {
  active: PropTypes.bool.isRequired
}

export default Switch



// WEBPACK FOOTER //
// ./src/components/Switch/index.js